import React, {memo} from 'react';
import {Grid, Typography} from "@mui/material";
import type {Account} from "../types/Account";
import type {Theme} from "@mui/material";
import PartnerFundingSourceItem from "./paymentMethods/PartnerFundingSourceItem";
import {determinePaymentImage} from "../util/PaymentUtils";
import {BankAccountStatus} from "./constants/securspace-constants";

const listContainerSx = (theme: Theme) => ({
  display: 'flex',
  border: `0.07rem solid ${theme.palette.grey[200]}`,
  borderRadius: '0.57rem',
});

interface PartnerFundingSourcesListProps {
  account: Account;
  onMenuAction: (actionName: string) => void;
  fundingSourceExists: boolean;
}

const PartnerFundingSourcesList = memo(
  function PaymentMethodsList(props: PartnerFundingSourcesListProps) {
    const {account, onMenuAction, fundingSourceExists} = props;

    const fundingSourceVerified = (): string | null => {
      if (!account.fundingSourceVerified) {
        return BankAccountStatus.UNVERIFIED;
      } else if (account.fundingSourceVerified) {
        return BankAccountStatus.VERIFIED;
      } else {
        return null;
      }
    }

    return (
      <Grid container direction={'column'} sx={listContainerSx}>
        {fundingSourceExists ? <PartnerFundingSourceItem
            bankName={account.existingFundingSourceBankName}
            bankAccountType={account.existingFundingSourceBankAccountType}
            nickName={account.existingFundingSourceAccountNickname}
            status={fundingSourceVerified()}
            img={determinePaymentImage({type: 'BANK'})}
            onMenuAction={onMenuAction}
          />
          : <Typography variant={'h5'} component={'strong'}>No Funding Source added yet</Typography>
        }
      </Grid>
    );
  });

export default PartnerFundingSourcesList;
